import * as yup from 'yup'
import { validateMessage, resetValidateMessage } from '~/resources/validate-message'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import { REGEX_SPECIAL_CHARACTER } from '~/constants'
import { BANKING_FORM_CRITERIA } from '~/validate/constant/banking-form'

export const getPasswordValidationSchema = (
  requiredText: string = 'Vui lòng nhập mật khẩu.'
): yup.StringSchema<string | undefined, object, undefined, ''> => {
  return yup
    .string()
    .required(requiredText)
    .min(AUTH_CRITERIA.PASSWORD_MIN_LENGTH, validateMessage.passwordValidate)
    .max(AUTH_CRITERIA.PASSWORD_MAX_LENGTH, validateMessage.passwordValidate)
    .test(AUTH_CRITERIA.NO_SPACE, validateMessage.notAllowSpace, value => !value.includes(' '))
}

export const getResetPasswordValidationSchema = (
  requiredText: string = 'Vui lòng nhập mật khẩu.'
): yup.StringSchema<string | undefined, object, undefined, ''> => {
  return yup
    .string()
    .required(requiredText)
    .min(AUTH_CRITERIA.PASSWORD_MIN_LENGTH, resetValidateMessage.min)
    .max(AUTH_CRITERIA.PASSWORD_MAX_LENGTH, validateMessage.max)
    .test(AUTH_CRITERIA.NO_SPACE, validateMessage.notAllowSpace, value => !value.includes(' '))
}

export const bankAccountNumberSchema = yup.string()
  .required('Vui lòng nhập số tài khoản')
  .matches(REGEX_SPECIAL_CHARACTER, 'Số tài khoản chỉ được nhập chữ và số')
  .min(BANKING_FORM_CRITERIA.BANK_ACCOUNT_NO_MIN_LENGTH, `
    Số tài khoản phải từ ${BANKING_FORM_CRITERIA.BANK_ACCOUNT_NO_MIN_LENGTH} đến
    ${BANKING_FORM_CRITERIA.BANK_ACCOUNT_NO_MAX_LENGTH} số
  `)
